<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fal fa-thumbtack" id="ico"></i>
		<h1 style="display: inline-block;">Paso por Punto</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<mat-card class="mt-3">
	<mat-card-content>
		<div class="row">
			<div class="col-md-12">
				<h4>Paso por punto</h4>
			</div>
			<div class="col-md-8">
				<span>Especifique un rango de tiempo en el cual desea obtener ubicaciones del vehiculo
					seleccionado.</span>
			</div>
			<div class="col-md-4">
				<div class="row" style="margin-left: 28%;">
					<kt-boton-exportar-tabla [tipoBoton]="'monitoreo'" [nombreArchivo]="'Reporte_Paso_Por_Punto'"
						[datos]="datosReporte" [buttonDisabled]="isDisabled">
					</kt-boton-exportar-tabla>
				</div>
			</div>
		</div>
		<dx-validation-group #targetGroup>
			<div class="row mt-3">
				<div class="col col-sm-12 col-md-12 col-lg-12">
					<div class="row">
						<div class="col col-sm-12 col-md-3 col-lg-3">
							<label>Fecha Inicial:</label>
							<dx-date-box [(value)]="fechaInicio" type="datetime" style="width: 100%;"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
						<div class="col col-sm-12 col-md-3 col-lg-3">
							<label>Fecha Final:</label>
							<dx-date-box [(value)]="fechaFin" style="width: 100%;" type="datetime"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
						<div class="col col-sm-12 col-md-3 col-lg-3">
							<label>Puntos de interes:</label>
							<dx-tag-box style="width: 100%;" [searchEnabled]="true" [items]="puntosInteres"
								[showSelectionControls]="true" displayExpr="nombre" valueExpr="id"
								placeholder="Selecciona punto" [(value)]="puntoInteres">
							</dx-tag-box>
						</div>
						<div class="col col-sm-12 col-md-3 col-lg-3 mt-3">
							<div class="row mt-3">
								<button id="boton" type="submit" class="btn btn-success"
									(click)="obtenerPasoPunto(fechaInicio, fechaFin)"><i
										class="fal fa-search"></i>Buscar</button>&nbsp;
							</div>
						</div>
					</div>
				</div>
			</div>
		</dx-validation-group>
		<mat-divider class="mt-3"></mat-divider>
		<div class="grid">
			<dx-data-grid *ngIf="showTable" id="gridContainer" [dataSource]="reportePasoPunto" [showBorders]="true"
				[columnHidingEnabled]="true">
				<dxo-paging [pageSize]="10"></dxo-paging>
				<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 50, 100]" [showInfo]="true">
				</dxo-pager>
				<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
				<dxi-column caption="Vehiculo" alignment="center" cellTemplate="Ubicar"></dxi-column>
				<dxi-column dataField="placas" caption="Placas" alignment="center"></dxi-column>
				<dxi-column dataField="estado" caption="Estado" alignment="center" cellTemplate="color">
				</dxi-column>
				<dxi-column dataField="ignicion" caption="Ignición" alignment="center"></dxi-column>
				<dxi-column dataField="fechaHora" alignment="center" dataType="date" format="M/d/yyyy">
					<dxo-header-filter [dataSource]="orderHeaderFilter"></dxo-header-filter>
				</dxi-column>
				<dxi-column dataField="distancia" caption="Distancia" alignment="center"></dxi-column>
				<dxi-column dataField="punto" caption="Punto" alignment="center"></dxi-column>
				<div *dxTemplate="let d of 'Ubicar'" style="text-align: center;">
					<a style="color: teal; cursor: pointer;" (click)="ubicarPunto(d.data)">{{d.data.descripcion}}</a>
				</div>
				<div *dxTemplate="let p of 'color'" style="text-align: center;">
					<span *ngIf="p.data.estado === 'Alerta Primaria'" class="rojo">{{p.data.estado}}</span>
					<span *ngIf="p.data.estado === 'Movimiento'" class="verde">{{p.data.estado}}</span>
					<span *ngIf="p.data.estado === 'Exceso de Velocidad'" class="azul">{{p.data.estado}}</span>
					<span *ngIf="p.data.estado === 'Detenido mas de 60 min'" class="naranja">{{p.data.estado}}
					</span>
					<span *ngIf="p.data.estado === 'Detenido'" class="gris">{{p.data.estado}}</span>
				</div>
			</dx-data-grid>
		</div>
	</mat-card-content>
</mat-card>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
